import { Modal } from "components/dashboard/Modal";
import React, { useState } from "react";

import bucksStackPng from "../../../assets/images/Liifer_bucks_stack.png";
import bucksStacksPng from "../../../assets/images/LiiferBucks_3Stacks.png";
import burgerPng from "../../../assets/images/burger-drink.png";
import smallStackPng from "../../../assets/images/LiiferBucks_SmallStack.png";
import closeSvg from "../../../assets/svg/close.svg";
import clockSvg from "../../../assets/svg/clock-icon.svg";
import arrowSvg from "../../../assets/svg/arrow.svg";
import backArrow from "../../../assets/svg/back-arrow.svg";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "hooks/useWindowSize";
import { IsRunningOverwolf } from "utilityFunctions";
import useApplicationInfo from "hooks/useAppInfo";
import { SmallInGameAppDownloadButton } from "../../../components/dashboard/SmallInGameAppDownloadButton";

type Props = {
  showLiiferBucksModal: boolean;
  setShowLiiferBucksModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const LiiferBucksModal: React.FC<Props> = ({
  showLiiferBucksModal,
  setShowLiiferBucksModal,
}) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { t } = useTranslation();
  const [width] = useWindowSize();
  const { application } = useApplicationInfo();
  const isRunningIos = application === "IOS_CLIENT";
  const capacitorIsRunning = application === "ANDROID_CLIENT" || isRunningIos;
  const language = t("localization_testing");

  const CloseButton = () => {
    return (
      <button
        onClick={() => {
          setShowLiiferBucksModal(false);
        }}
        type="button"
        className=" lg:-mr-4 z-10 hover:opacity-70 transition duration-200 ease-in-out"
      >
        <img className="h-8 lg:h-10" src={closeSvg} alt="close" />
      </button>
    );
  };

  const PageOne = () => {
    const shortenedText = width <= 640;
    return (
      <div
        className={`h-full flex flex-col justify-center items-center text-slate-200 sm:pt-10 ${
          language === "fr" ? "pt-48" : "pt-16"
        }`}
      >
        <h3 className=" text-[#87FCF7] text-xl lg:text-2xl font-semibold">
          {t("liiferbucksmodal.page1Subtitle")}
        </h3>
        <div className="pt-6">
          <span className="text-slate-200 text-lg pr-1 font-medium">
            {t("liiferbucksmodal.page1Subtext2")}
          </span>
          <span className="text-slate-200 pr-1 font-medium">
            {t("liiferbucksmodal.maxLiiferBucks")}
          </span>
          <br />
          <span className="text-[#87FCF7] text-lg pr-1">
            {t("liiferbucksmodal.page1Subtext3")}
          </span>
        </div>
        <div className="flex justify-between w-full py-4 lg:pt-8">
          <div className="w-1/3 flex flex-col items-center justify-center space-y-1">
            <img src={clockSvg} alt="clock" className="h-10 lg:h-12" />
            <span className="text-slate-200 font-semibold text-sm lg:text-base">
              {t("liiferbucksmodal.1hOfGaming")}
            </span>
          </div>
          <div className="w-1/3 flex items-center justify-center">
            <img src={arrowSvg} alt="arrow" className="h-7 lg:h-8" />
          </div>
          <div className="w-1/3 flex flex-col items-center justify-center">
            <img
              className="h-12 lg:h-14"
              src={smallStackPng}
              alt="liifer bucks"
            />
            <span className="text-slate-200 font-semibold text-sm lg:text-base">
              {t("liiferbucksmodal.50LiiferBucks")}
            </span>
          </div>
        </div>
        <div className="px-3">
          <p className="text-slate-200 px-4 lg:px-1 pt-2 lg:pt-6 font-medium text-lg">
            {shortenedText
              ? t("liiferbucksmodal.page1Info").substring(
                  30,
                  t("liiferbucksmodal.page1Info").length
                )
              : t("liiferbucksmodal.page1Info")}
          </p>
          <span className="text-xs">{t("liiferbucksmodal.page1InfoSub")}</span>
        </div>
      </div>
    );
  };

  const PageTwo = () => {
    return (
      <div
        className={`h-full flex flex-col justify-center items-center text-slate-200 sm:pt-10 mx-4 md:mx-0 ${
          language === "fr" ? "pt-20" : "pt-10"
        }`}
      >
        <h3 className="text-[#87FCF7] text-xl lg:text-2xl font-semibold">
          {t("liiferbucksmodal.page2Subtitle")}
        </h3>
        <div className="md:pt-6 lg:pt-8">
          <ol className="text-center md:text-left sm:text-base md:text-lg lg:text-lg">
            <li className="py-4 lg:flex items-center">
              {t("liiferbucksmodal.page2ItemList1")}
              {!IsRunningOverwolf() && !capacitorIsRunning && (
                <div className="pl-2 hidden lg:block">
                  <SmallInGameAppDownloadButton />
                </div>
              )}
              <div className="lg:hidden">
                &nbsp;
                {t("liiferbucksmodal.onPC")}
              </div>
            </li>
            <li className="py-4">{t("liiferbucksmodal.page2ItemList2")}</li>
            <li className="py-4">{t("liiferbucksmodal.page2ItemList3")}</li>
            <li className="py-4">{t("liiferbucksmodal.page2ItemList4")}</li>
          </ol>
        </div>
      </div>
    );
  };

  const PageThree = () => {
    return (
      <div className="h-full flex flex-col justify-center items-center text-slate-200 pt-16 sm:pt-0">
        <h3 className="text-[#87FCF7] text-xl lg:text-2xl font-semibold">
          {t("liiferbucksmodal.page3Subtitle")}
        </h3>
        <p className="text-slate-200 pt-12 lg:pt-8 font-medium px-4 text-lg">
          {t("liiferbucksmodal.page3Subtext")}
        </p>
        <div className="flex justify-between items-center w-full pt-4 lg:pt-10 px-2">
          <div className="w-1/3 flex flex-col items-center justify-center space-y-1">
            <img src={burgerPng} alt="clock" className="h-16" />
          </div>
          <div className="w-1/3 flex items-center justify-center">
            <img src={arrowSvg} alt="arrow" className="h-8 -mt-1" />
          </div>
          <div className="w-1/3 flex flex-col items-center justify-center">
            <img className=" h-20" src={bucksStackPng} alt="liifer bucks" />
          </div>
        </div>
      </div>
    );
  };

  const PageFour = () => {
    return (
      <div className="h-full flex flex-col justify-center items-center text-slate-200">
        <h3 className="text-[#87FCF7] text-xl lg:text-2xl font-semibold mx-4">
          {t("liiferbucksmodal.page4Subtitle")}
        </h3>
        <div className="flex items-center justify-center space-x-8 pt-4 pb-6 lg:py-10">
          <span className="text-5xl lg:text-4xl font-bold">{"2X"}</span>
          <img
            className="h-20 lg:h-32"
            src={bucksStacksPng}
            alt="liifer bucks"
          />
        </div>
        <div className="pt-2 mx-2">
          <p className="font-medium text-lg">
            {t("liiferbucksmodal.page4Subtext")}
          </p>
        </div>
      </div>
    );
  };

  const ModalControls = () => {
    return (
      <div
        className={`flex items-center justify-center -mb-2 md:-mb-0 lg:ml-3 ${
          language === "fr" ? "pt-44 sm:pt-16" : "pt-16 sm:pt-10"
        }`}
      >
        <div className="w-8 flex item-center ">
          {currentPage > 1 && (
            <button
              type="button"
              className="hover:opacity-70 transition duration-200 ease-in-out"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              <img className="h-7" src={backArrow} alt="back" />
            </button>
          )}
        </div>
        <div>
          {(currentPage === 1 || currentPage === 2) && (
            <button
              type="button"
              onClick={() => setCurrentPage(currentPage + 1)}
              className="px-10 py-2 border-2 rounded-md border-[#87FCF7] font-medium text-lg hover:opacity-70 transition duration-200 ease-in-out"
            >
              {t("form.next")}
            </button>
          )}
          {currentPage === 3 && (
            <button
              type="button"
              onClick={() => setCurrentPage(currentPage + 1)}
              className="px-10 py-2 border-2 rounded-md border-[#87FCF7] font-medium text-lg hover:opacity-70 transition duration-200 ease-in-out"
            >
              {t("form.next")}
            </button>
          )}
          {currentPage === 4 && (
            <button
              type="button"
              onClick={() => setShowLiiferBucksModal(false)}
              className="px-10 py-2 border-2 rounded-md border-[#87FCF7] font-medium text-lg hover:opacity-70 transition duration-200 ease-in-out"
            >
              {t("form.okay")}
            </button>
          )}
        </div>
        <div>
          <span className="text-slate-200 text-lg pl-2 lg:pl-4">{`${currentPage}/4`}</span>
        </div>
      </div>
    );
  };

  return (
    <Modal
      show={showLiiferBucksModal}
      customModal={
        <div className="w-full bg-slate-800 pt-2 pb-6 sm:pb-10 px-1 sm:px-6 text-[#87FCF7]">
          <>
            <div className="w-full flex justify-end sm:-mb-2">
              <CloseButton />
            </div>
            <div className="h-96">
              {currentPage === 1 && <PageOne />}
              {currentPage === 2 && <PageTwo />}
              {currentPage === 3 && <PageThree />}
              {currentPage === 4 && <PageFour />}
            </div>
            <ModalControls />
          </>
        </div>
      }
    />
  );
};

export default LiiferBucksModal;
